/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Cost_MissingInputs */

const en_cost_missing = /** @type {(inputs: Cost_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No price for: ${i?.names}.`)
};

const de_cost_missing = /** @type {(inputs: Cost_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ohne Preis: ${i?.names}.`)
};

/**
* | output |
* | --- |
* | "No price for: {names}." |
*
* @param {Cost_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_missing = /** @type {((inputs: Cost_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cost_missing(inputs)
	return en_cost_missing(inputs)
});